import * as drawing_utils from '@mediapipe/drawing_utils';
import * as Holistic from '@mediapipe/holistic';

export function drawOnCanvas(canvas: HTMLCanvasElement, results: any, shouldClear: boolean = true): void {
    const ctx = canvas.getContext('2d')!;
    if (!canvas.width || !canvas.height) {
        canvas.width = canvas.clientWidth || 640;
        canvas.height = canvas.clientHeight || 480;
    }
    ctx.save();
    if (shouldClear) {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
    }

    ctx.lineWidth = 1;
    if (results?.poseLandmarks) {
        if (results.rightHandLandmarks) {
            ctx.strokeStyle = 'rgba(255,255,255,0.5)';
            connect(ctx, [[
                results.poseLandmarks[Holistic.POSE_LANDMARKS.RIGHT_ELBOW],
                results.rightHandLandmarks[0],
            ]]);
        }
        if (results.leftHandLandmarks) {
            ctx.strokeStyle = 'rgba(255,255,255,0.5)';
            connect(ctx, [[
                results.poseLandmarks[Holistic.POSE_LANDMARKS.LEFT_ELBOW],
                results.leftHandLandmarks[0],
            ]]);
        }
    }

    drawing_utils.drawConnectors(
        ctx, results.poseLandmarks, Holistic.POSE_CONNECTIONS,
        { color: 'rgba(255,255,255,0.5)', lineWidth: 1 });
    drawing_utils.drawLandmarks(
        ctx,
        Object.values(Holistic.POSE_LANDMARKS_LEFT)
            .map((index: any) => results.poseLandmarks?.[index]),
        { visibilityMin: 0.65, color: 'rgba(255,255,255,0.5)', lineWidth: 1, fillColor: 'rgba(255,138,0,0.5)' });
    drawing_utils.drawLandmarks(
        ctx,
        Object.values(Holistic.POSE_LANDMARKS_RIGHT)
            .map((index: any) => results.poseLandmarks?.[index]),
        { visibilityMin: 0.65, color: 'rgba(255,255,255,0.5)', lineWidth: 1, fillColor: 'rgba(0,217,231,0.5)' });

    drawing_utils.drawConnectors(
        ctx, results.rightHandLandmarks, Holistic.HAND_CONNECTIONS,
        { color: 'rgba(255,255,255,0.5)', lineWidth: 2 });
    drawing_utils.drawLandmarks(ctx, results.rightHandLandmarks, {
        color: 'rgba(255,255,255,0.5)',
        fillColor: 'rgba(0,217,231,0.5)',
        lineWidth: 1,
        radius: (data: any) => drawing_utils.lerp(data.from!.z!, -0.15, .1, 10, 1),
    });
    drawing_utils.drawConnectors(
        ctx, results.leftHandLandmarks, Holistic.HAND_CONNECTIONS,
        { color: 'rgba(255,255,255,0.5)', lineWidth: 1 });
    drawing_utils.drawLandmarks(ctx, results.leftHandLandmarks, {
        color: 'rgba(255,255,255,0.5)',
        fillColor: 'rgba(255,138,0,0.5)',
        lineWidth: 1,
        radius: (data: any) => drawing_utils.lerp(data.from!.z!, -0.15, .1, 10, 1),
    });

    ctx.restore();
}

export function connect(
    ctx: CanvasRenderingContext2D,
    connectors: Array<[Holistic.NormalizedLandmark, Holistic.NormalizedLandmark]>,
): void {
    const canvas = ctx.canvas;
    for (const connector of connectors) {
        const from = connector[0];
        const to = connector[1];
        if (from && to) {
            if (from.visibility && to.visibility && (from.visibility < 0.1 || to.visibility < 0.1)) {
                continue;
            }
            ctx.beginPath();
            ctx.moveTo(from.x * canvas.width, from.y * canvas.height);
            ctx.lineTo(to.x * canvas.width, to.y * canvas.height);
            ctx.stroke();
        }
    }
}


